import React from 'react';
import PropTypes from 'prop-types';
import Add3Icon from 'zignal-landscape/lib/Icon/Add3Icon';
import AlignLeftIcon from 'zignal-landscape/lib/Icon/AlignLeftIcon';
import PdfIcon from 'zignal-landscape/lib/Icon/PdfIcon';
import SwfIcon from 'zignal-landscape/lib/Icon/SwfIcon';
import IFrameIcon from 'zignal-landscape/lib/Icon/IFrameIcon';
import TabbedPanes from 'zignal-landscape/lib/TabbedPanes';
import Tabs from 'zignal-landscape/lib/Tabs';
import Tab from 'zignal-landscape/lib/Tab';
import Panes from 'zignal-landscape/lib/Panes';
import Pane from 'zignal-landscape/lib/Pane';
import omit from 'lodash/omit';

import styles from './CreateView.css';
import FreeformForm from './FreeformForm.js';
import FileUploadForm from './FileUploadForm.js';
import IframeForm from './IframeForm.js';

export default class CreateView extends React.Component {
  constructor(props) {
    super(props);

    this.createCustomWidget = this.createCustomWidget.bind(this);

    this.state = Object.assign({}, props.widgetData);
  }

  createCustomWidget(data) {
    const { addNewWidget } = this.props;
    const unixTimestamp = Math.floor(Date.now() / 1000);
    const transformedData = Object.assign(
      {
        name: data.title,
        createdAt: unixTimestamp,
        type: 'custom'
      },
      omit(data, ['modifiedAt'])
    );

    addNewWidget(transformedData);
  }

  render() {
    const { cancelCreation, fileUploadUrl } = this.props;

    return (
      <div className={styles.wrapper}>

        <header className={styles.header}>
          <Add3Icon />
          <h4 className={styles.viewTitle}>
            Create New Custom Widget
          </h4>
          <p className={styles.description}>Freeform, PDF, SWF, iframe</p>
        </header>

        <div className={styles.tabbedPanesWrapper}>
          <TabbedPanes>
            <Tabs>
              <Tab>
                <AlignLeftIcon />
                <span className={styles.tabLabel}>Freeform</span>
              </Tab>
              <Tab>
                <PdfIcon />
                <span className={styles.tabLabel}>PDF</span>
              </Tab>
              <Tab>
                <SwfIcon />
                <span className={styles.tabLabel}>SWF</span>
              </Tab>
              <Tab>
                <IFrameIcon />
                <span className={styles.tabLabel}>iFrame</span>
              </Tab>
            </Tabs>

            <Panes>
              <Pane>
                <FreeformForm
                  fileUploadUrl={fileUploadUrl}
                  onCancel={cancelCreation}
                  onSubmit={this.createCustomWidget}
                />
              </Pane>
              <Pane>
                <FileUploadForm
                  fileExtension="pdf"
                  description="PDF lets you upload and display any PDF document."
                  fileUploadUrl={fileUploadUrl}
                  onCancel={cancelCreation}
                  onSubmit={this.createCustomWidget}
                />
              </Pane>
              <Pane>
                <FileUploadForm
                  fileExtension="swf"
                  description="SWF lets you upload and display a Shockwave file.
                    <em>Note: Requesting external data like SWF files may not function properly.</em>"
                  fileUploadUrl={fileUploadUrl}
                  onCancel={cancelCreation}
                  onSubmit={this.createCustomWidget}
                />
              </Pane>
              <Pane>
                <IframeForm
                  onCancel={cancelCreation}
                  onSubmit={this.createCustomWidget}
                />
              </Pane>
            </Panes>
          </TabbedPanes>
        </div>
      </div>
    );
  }
}

CreateView.propTypes = {
  addNewWidget: PropTypes.func.isRequired,
  cancelCreation: PropTypes.func.isRequired,
  fileUploadUrl: PropTypes.string,
  widgetData: PropTypes.object
};
CreateView.defaultProps = {
  widgetData: {
    title: '',
    subtitle: '',
    content: ''
  }
};
